import { EmployeeEngagementDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/store/employeeEngagement.store.types';

export const EMPLOYEE_ENGAGEMENT_DATA_LOCKED_STUB: Partial<EmployeeEngagementDashboardStore> = {
  totalTeamMembers: 140,
  fullTimeMembers: 52,
  partTimeMembers: 48,
  smartphoneAppUsers: 118,
  casualMembers: 28,
  flexMembers: 12,
  hoursWorked: [
    { teamMember: 'Olanike Bamimore', hoursWorked: 130 },
    { teamMember: 'Leonardo Epistola', hoursWorked: 115 },
    { teamMember: 'Ruslan Yeltsov', hoursWorked: 100 },
    { teamMember: 'Catherine Mantiquilla', hoursWorked: 95 },
    { teamMember: 'Dhrumil Patel', hoursWorked: 85 },
    { teamMember: 'Ya Zheng', hoursWorked: 78 },
    { teamMember: 'Nora Flutur', hoursWorked: 72 },
    { teamMember: 'Navdeep Kaur', hoursWorked: 65 },
    { teamMember: 'Carla Joy Casupanan', hoursWorked: 60 },
    { teamMember: 'Gemalyn Valdez', hoursWorked: 55 },
  ],
  pickups: [
    { teamMemberName: 'Catherine Chemutaai', type: 'Casual', numberOfShifts: 8 },
    { teamMemberName: 'Alice Maina', type: 'Casual', numberOfShifts: 8 },
    { teamMemberName: 'Marvie Concordia', type: 'Casual', numberOfShifts: 7 },
    { teamMemberName: 'Princess Ambrocio', type: 'Casual', numberOfShifts: 7 },
    { teamMemberName: 'Faith Solis', type: 'Casual', numberOfShifts: 7 },
  ],
  lastAppOpened: [
    { bucket: 'Today', count: 37 },
    { bucket: '1-3 days', count: 31 },
    { bucket: '4-7 days', count: 24 },
    { bucket: '8-14 days', count: 18 },
    { bucket: '15-30 days', count: 14 },
    { bucket: '30+ days', count: 15 },
  ],
  shiftAcceptanceLeaderboard: [
    {
      rank: 1,
      teamMember: 'M. Thompson',
      position: 'Wellness Nurse',
      type: 'Full-Time',
      shiftsAccepted: 14,
    },
    {
      rank: 2,
      teamMember: 'S. Okafor',
      position: 'Resident Care Partner (PSW)',
      type: 'Full-Time',
      shiftsAccepted: 12,
    },
    {
      rank: 3,
      teamMember: 'A. Williams',
      position: 'Resident Care Partner (PSW)',
      type: 'Full-Time',
      shiftsAccepted: 11,
    },
    {
      rank: 4,
      teamMember: 'R. Chen',
      position: 'Medication Care Partner',
      type: 'Part-Time',
      shiftsAccepted: 10,
    },
    {
      rank: 5,
      teamMember: 'L. Patel',
      position: 'Wellness Nurse',
      type: 'Full-Time',
      shiftsAccepted: 9,
    },
  ],
  topFulfillment: [
    {
      teamMemberId: '1',
      teamMemberName: 'Alice Maina',
      position: 'Resident Care Partner (PSW)',
      shiftCount: 8,
      averageResponseTimeHours: 0.01,
    },
    {
      teamMemberId: '2',
      teamMemberName: 'Catherine Chemutaai',
      position: 'Resident Care Partner (PSW)',
      shiftCount: 8,
      averageResponseTimeHours: 0.08,
    },
    {
      teamMemberId: '3',
      teamMemberName: 'Marvelous Isibor',
      position: 'Resident Care Partner (PSW)',
      shiftCount: 7,
      averageResponseTimeHours: 0.11,
    },
  ],
  topFulfillmentPage: 1,
  topFulfillmentTotalPages: 1,
  topCancellations: [
    {
      teamMemberId: '1',
      teamMemberName: 'Imelda Ibea',
      cancelledCounts: 9,
      acceptCounts: 9,
      cancellationRate: 100,
    },
    {
      teamMemberId: '2',
      teamMemberName: 'Laurice Eppers',
      cancelledCounts: 5,
      acceptCounts: 5,
      cancellationRate: 100,
    },
    {
      teamMemberId: '3',
      teamMemberName: 'Lily Adofo',
      cancelledCounts: 5,
      acceptCounts: 5,
      cancellationRate: 100,
    },
  ],
  topCancellationsPage: 1,
  topCancellationsTotalPages: 1,
  cancellationByPosition: [
    {
      positionId: '1',
      position: 'Housekeeper',
      totalShiftCount: 50,
      cancelledShiftCount: 27,
      cancelledPrct: 54,
    },
    {
      positionId: '2',
      position: 'Cook',
      totalShiftCount: 40,
      cancelledShiftCount: 18,
      cancelledPrct: 45,
    },
    {
      positionId: '3',
      position: 'Resident Care Partner (PSW)',
      totalShiftCount: 120,
      cancelledShiftCount: 48,
      cancelledPrct: 40,
    },
    {
      positionId: '4',
      position: 'Wellness Nurse',
      totalShiftCount: 60,
      cancelledShiftCount: 19,
      cancelledPrct: 31,
    },
  ],
  calloutAcceptance: [
    {
      teamMemberId: '1',
      teamMemberName: 'R. Chen',
      position: 'Medication Care Partner',
      type: 'Part-Time',
      calloutsSent: 22,
      calloutsAccepted: 16,
      acceptanceRate: 72.7,
      averageResponseSpeedMinutes: 18,
    },
    {
      teamMemberId: '2',
      teamMemberName: 'L. Patel',
      position: 'Wellness Nurse',
      type: 'Full-Time',
      calloutsSent: 20,
      calloutsAccepted: 15,
      acceptanceRate: 75,
      averageResponseSpeedMinutes: 22,
    },
    {
      teamMemberId: '3',
      teamMemberName: 'M. Thompson',
      position: 'Wellness Nurse',
      type: 'Full-Time',
      calloutsSent: 18,
      calloutsAccepted: 14,
      acceptanceRate: 77.8,
      averageResponseSpeedMinutes: 12,
    },
    {
      teamMemberId: '4',
      teamMemberName: 'J. Nguyen',
      position: 'Medication Care Partner',
      type: 'Part-Time',
      calloutsSent: 12,
      calloutsAccepted: 7,
      acceptanceRate: 58.3,
      averageResponseSpeedMinutes: 45,
    },
  ],
  calloutAcceptancePage: 1,
  calloutAcceptanceTotalPages: 1,
};
